export default __webpack_public_path__ + "static/media/petit_journal.c3ab8ba5.png";